export default __webpack_public_path__ + "static/media/people1small.3cc5bc64.jpg";